import { render, staticRenderFns } from "./Officials.vue?vue&type=template&id=21a63bc4&"
import script from "./Officials.vue?vue&type=script&lang=js&"
export * from "./Officials.vue?vue&type=script&lang=js&"
import style0 from "./Officials.vue?vue&type=style&index=0&id=21a63bc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports